import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupItemButtonsComponent } from './group-item-buttons.component';

@NgModule({
  declarations: [
    GroupItemButtonsComponent  // Declare the component here
  ],
  imports: [
    CommonModule  // Import necessary Angular modules
  ],
  exports: [
    GroupItemButtonsComponent  // Export the component to be used in other modules if needed
  ]
})
export class GroupItemButtonsModule { }
